import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import boardData from "./boardData";
import { listBoards, getBoard, createRoom, hostStorageKey } from "./api";
import "./jeopardy.css";

const SAMPLE_GAME = { id: null, name: "Sample Game (built-in)" };

export default function GameSelect() {
    const navigate = useNavigate();
    const [boards, setBoards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [starting, setStarting] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        listBoards()
            .then((res) => {
                if (cancelled) return;
                setBoards(res.boards || []);
                setLoading(false);
            })
            .catch(() => {
                if (cancelled) return;
                setError("Could not load saved games.");
                setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    async function handleSelect(entry) {
        setStarting(true);
        setError(null);
        try {
            const rounds = entry.id === null ? boardData.rounds : (await getBoard(entry.id)).rounds;
            const res = await createRoom(rounds);
            if (res.error) throw new Error(res.error);
            localStorage.setItem(hostStorageKey(res.code), res.hostToken);
            navigate(`/jeopardy/${res.code}`);
        } catch (e) {
            setError("Could not start that game. Please try again.");
            setStarting(false);
        }
    }

    const allEntries = [SAMPLE_GAME, ...boards];

    return (
        <div className="jpd-home">
            <h1 className="jpd-title">Choose a Game</h1>

            {loading && <div className="jpd-muted" style={{ textAlign: "center" }}>Loading saved games…</div>}
            {error && <div className="jpd-error">{error}</div>}

            <div className="jpd-panel jpd-panel-wide">
                {!loading &&
                    allEntries.map((entry) => (
                        <button
                            key={entry.id === null ? "sample" : entry.id}
                            className="jpd-game-row"
                            disabled={starting}
                            onClick={() => handleSelect(entry)}
                        >
                            <span>{entry.name}</span>
                            {entry.updatedAt && <span className="jpd-muted">{entry.updatedAt}</span>}
                        </button>
                    ))}
            </div>

            <div className="jpd-panel" style={{ textAlign: "center" }}>
                <p>Don't see the game you want?</p>
                <Link className="jpd-btn jpd-btn-primary" to="/jeopardy/builder">
                    Build a New Game
                </Link>
            </div>

            <div style={{ textAlign: "center" }}>
                <Link className="jpd-btn" to="/jeopardy">
                    Back
                </Link>
            </div>
        </div>
    );
}
